import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import PreviousIncumbentDetail from './PreviousIncumbentDetail';
import { cloneDeep, get, isArray, isEmpty } from 'lodash';
import positionProfileApi from '../../services/positionProfileApi';
import PositionProfileMatchingCriteria from './PositionProfileMatchingCriteria/PositionProfileMatchingCriteria';
import CriticalityPositionStatusHistory from '../../components/CriticalityPositionStatusHistory/CriticalityPositionStatusHistory';
import PositionProfileNotes from './PositionProfileNotes/PositionProfileNotes';
import PositionProfileReportLine from './PositionProfileReportLine/PositionProfileReportLine';
import { useSelector } from 'react-redux';
import { PERMISSION } from '../../utils/constants';

const InitialTabs = [
  { id: 1, label: 'All' },
  { id: 2, label: 'Position Holder Details' },
  { id: 3, label: 'SPUR' },
  { id: 4, label: 'Matching Criteria' },
  { id: 5, label: 'Criticality History' },
  { id: 6, label: 'Reporting Line' },
  { id: 7, label: 'Notes' },
];
const Navbar = styled.div`
  display: flex;
  margin-top: 24px;
  justify-content: start;
  align-items: center;
  width: 100%;
`;

const Title = styled.div`
  font-size: 24px;
  font-weight: 700;
  line-height: 24px;
  margin-right: 20px;
  flex-shrink: 0;
`;

const TabItem = styled.div`
  padding: 16px 24px;
  min-width: 106px;
  width: fit-content;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0.0168em;
  text-align: ${(props) => (props?.id === 7 ? 'left' : 'center')};
  cursor: pointer;
  color: ${(props) => (props?.active ? '#007874' : '#181818')};
  border-bottom: ${(props) => (props?.active ? '2px solid #00A19C' : 'unset')};
  transition: 0.5s ease-in-out;
  white-space: nowrap;
`;

const TabWrap = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  border-bottom: solid 1px #c9d5e3;
`;

const SecondSectionPosition = (props) => {
  const { position_code, roleActive } = props;
  const permissions = useSelector((state) => state.user.permissions);

  const [tabs, setTabs] = useState(InitialTabs);
  const [tabIds, setTabIds] = useState(InitialTabs.map((i) => i.id));
  const [tabSelected, setTabSelected] = useState(InitialTabs[0].id);
  const [incumbent, setInCumbent] = useState({ page: 1, limit: 15, total: 0, data: [], loading: false });

  useEffect(() => {
    if (isArray([permissions])) {
      let tempPer = cloneDeep(InitialTabs);
      if (!permissions.includes(PERMISSION.POSITION_INSIGHTS_ALL)) {
        tempPer = tempPer.filter((i) => i.id !== 1);
      }
      if (!permissions.includes(PERMISSION.POSITION_INSIGHTS_POSITION_HOLDER_DETAILS)) {
        tempPer = tempPer.filter((i) => i.id !== 2);
      }
      if (!permissions.includes(PERMISSION.POSITION_INSIGHTS_SPUR)) {
        tempPer = tempPer.filter((i) => i.id !== 3);
      }
      if (!permissions.includes(PERMISSION.POSITION_INSIGHTS_MATCHING_CRITERIA)) {
        tempPer = tempPer.filter((i) => i.id !== 4);
      }
      if (!permissions.includes(PERMISSION.POSITION_INSIGHTS_CRITICALITY_HISTORY)) {
        tempPer = tempPer.filter((i) => i.id !== 5);
      }
      if (!permissions.includes(PERMISSION.POSITION_INSIGHTS_REPORTING_LINE)) {
        tempPer = tempPer.filter((i) => i.id !== 6);
      }
      if (!permissions.includes(PERMISSION.POSITION_INSIGHTS_NOTES)) {
        tempPer = tempPer.filter((i) => i.id !== 7);
      }
      setTabs(tempPer || []);
      setTabIds(!isEmpty(tempPer) ? tempPer.map((i) => i.id) : []);
      setTabSelected(!isEmpty(tempPer) ? tempPer[0].id : null);
    }
  }, [permissions, setTabs]);

  async function fetchPositionIncumbentDetail(page) {
    try {
      setInCumbent((prev) => ({ ...prev, loading: true }));
      const res = await positionProfileApi.getPositionIncumbentDetail({ position_code, limit: 15, page: page }, roleActive?.roleId);
      setInCumbent((prev) => ({ ...prev, total: get(res, 'data.result.total'), data: get(res, 'data.result.data'), page, loading: false }));
    } catch (error) {
      console.error(error);
      setInCumbent((prev) => ({ ...prev, total: 0, data: [], page: 1, loading: false }));
    }
  }
  useEffect(() => {
    if (!position_code || !roleActive?.roleId) return;
    fetchPositionIncumbentDetail(1);
  }, [position_code, roleActive?.roleId]);

  return (
    <div>
      <Navbar>
        <Title>Position Insights</Title>
        <TabWrap>
          {tabs.map((m) => (
            <TabItem active={m.id === tabSelected ? true : false} key={'position-tab' + m.id} id={m.id} onClick={() => setTabSelected(m.id)}>
              {m.label}
            </TabItem>
          ))}
        </TabWrap>
      </Navbar>
      {tabSelected === 1 && (
        <>
          {tabIds.includes(1) && <div style={{ marginTop: '25px' }}></div>}
          {tabIds.includes(2) && (
            <div style={{ marginTop: '25px' }}>
              <PreviousIncumbentDetail incumbent={incumbent} fetchPositionIncumbentDetail={fetchPositionIncumbentDetail} />
            </div>
          )}
          {tabIds.includes(3) && <div style={{ marginTop: '25px' }}></div>}
          {tabIds.includes(4) && (
            <div style={{ marginTop: '25px' }}>
              <PositionProfileMatchingCriteria positionCode={position_code} />
            </div>
          )}
          {tabIds.includes(5) && (
            <div style={{ marginTop: '25px' }}>
              <CriticalityPositionStatusHistory positionCode={position_code} />
            </div>
          )}
          {tabIds.includes(6) && (
            <div style={{ marginTop: '25px' }}>
              <PositionProfileReportLine positionCode={position_code} />
            </div>
          )}
          {tabIds.includes(7) && (
            <div style={{ marginTop: '25px' }}>
              <PositionProfileNotes positionCode={position_code} />
            </div>
          )}
        </>
      )}
      {tabSelected === 2 && (
        <div style={{ marginTop: '25px' }}>
          <PreviousIncumbentDetail incumbent={incumbent} fetchPositionIncumbentDetail={fetchPositionIncumbentDetail} />
        </div>
      )}
      {tabSelected === 3 && <div style={{ marginTop: '25px' }}>{InitialTabs[2].label}</div>}
      {tabSelected === 4 && (
        <div style={{ marginTop: '25px' }}>
          <PositionProfileMatchingCriteria positionCode={position_code} />
        </div>
      )}
      {tabSelected === 5 && (
        <div style={{ marginTop: '25px' }}>
          <CriticalityPositionStatusHistory positionCode={position_code} />
        </div>
      )}
      {tabSelected === 6 && (
        <div style={{ marginTop: '25px' }}>
          <PositionProfileReportLine positionCode={position_code} />
        </div>
      )}
      {tabSelected === 7 && (
        <div style={{ marginTop: '25px' }}>
          <PositionProfileNotes positionCode={position_code} />
        </div>
      )}
    </div>
  );
};

export default SecondSectionPosition;
